var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmniaAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_324268_11728)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0023 6.16756C9.67664 6.16756 6.17 9.6742 6.17 13.9999C6.17 18.3255 9.67664 21.8322 14.0023 21.8322C18.328 21.8322 21.8346 18.3255 21.8346 13.9999C21.8346 13.6768 22.0965 13.4149 22.4196 13.4149C22.7427 13.4149 23.0046 13.6768 23.0046 13.9999C23.0046 18.9717 18.9741 23.0022 14.0023 23.0022C9.03047 23.0022 5 18.9717 5 13.9999C5 9.02803 9.03047 4.99756 14.0023 4.99756C14.3254 4.99756 14.5873 5.25947 14.5873 5.58256C14.5873 5.90565 14.3254 6.16756 14.0023 6.16756Z",
    fill: "#009A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7314 14.195C11.9149 15.2959 12.7776 16.1587 13.8786 16.3422C14.0969 16.3786 14.0969 16.6923 13.8786 16.7287C12.7776 16.9122 11.9149 17.775 11.7314 18.8759C11.695 19.0942 11.3813 19.0942 11.3449 18.8759C11.1614 17.775 10.2986 16.9122 9.19764 16.7287C8.97937 16.6923 8.97937 16.3786 9.19764 16.3422C10.2986 16.1587 11.1614 15.2959 11.3449 14.195C11.3813 13.9767 11.695 13.9767 11.7314 14.195Z",
    fill: "#009A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9263 5.36499C17.4205 8.32998 19.7439 10.6534 22.7089 11.1476C23.1474 11.2207 23.1474 11.8509 22.7089 11.924C19.7439 12.4181 17.4205 14.7416 16.9263 17.7066C16.8532 18.145 16.223 18.145 16.1499 17.7066C15.6557 14.7416 13.3323 12.4181 10.3673 11.924C9.92883 11.8509 9.92883 11.2207 10.3673 11.1476C13.3323 10.6534 15.6557 8.32998 16.1499 5.36499C16.223 4.92651 16.8532 4.92651 16.9263 5.36499Z",
    fill: "url(#paint0_linear_324268_11728)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_324268_11728",
    x1: 16.538,
    y1: 3.03613,
    x2: 16.538,
    y2: 20.0361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#86BC25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046A38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_324268_11728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmniaAi);
export default __webpack_public_path__ + "static/media/omnia-ai.61c71d1f16a80cd6f1a92dc76fab3db4.svg";
export { ForwardRef as ReactComponent };